module.exports = __webpack_public_path__ + "static/GorditaRegular-Italic-631ce8d70265869acc537004c1e11f8b.otf";